import { ImagePreviewBody } from './atoms/image-preview-body';
import { ImageContent } from './components/image-content';
import { Controls } from './components/image-controls';
import { ImagePreviewModal } from './components/image-preview-modal';
import { ImagePreviewProvider } from './provider/image-preview.provider';

interface ImagePreviewProps {
  src: string;
  alt: string;
  onClose: () => void;
  children: React.ReactNode;
}

const ImagePreviewRoot = ({ src, alt, onClose, children }: ImagePreviewProps) => {
  return (
    <ImagePreviewProvider src={src} alt={alt} onClose={onClose}>
      {children}
    </ImagePreviewProvider>
  );
};

const ImagePreviewNamespace = Object.assign(ImagePreviewRoot, {
  Body: ImagePreviewBody,
  ImageContent: ImageContent,
  Controls: Controls,
  Modal: ImagePreviewModal,
});

export { ImagePreviewNamespace as ImagePreview };
